import React from "react";
import { Sparkles } from "lucide-react";

/**
 * Diwali 2026 is Sun, Nov 8. Allowing 8–12 business days (3–5 production + 5–7 shipping)
 * = order by Fri, Oct 23 for safety across most pincodes.
 * Band renders until (and including) the cutoff date.
 */
const DIWALI_YEAR = 2026;
const CUTOFF_DATE = new Date(DIWALI_YEAR, 9, 23); // Month is 0-indexed → October 23
const DIWALI_DATE = new Date(DIWALI_YEAR, 10, 8); // November 8

const DiwaliBanner = () => {
  const now = new Date();
  if (now > CUTOFF_DATE) return null;
  if (now > DIWALI_DATE) return null;

  const fmt = (d) => d.toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" });
  const daysLeft = Math.max(0, Math.ceil((CUTOFF_DATE - now) / (1000 * 60 * 60 * 24)));

  return (
    <div
      data-testid="diwali-banner"
      className="mt-6 flex items-start gap-3 p-4 border-l-2 border-[var(--copper)] bg-[var(--copper)]/5"
    >
      <Sparkles className="w-4 h-4 text-[var(--copper)] mt-0.5 flex-shrink-0" />
      <div className="text-sm text-[var(--espresso)]/80 leading-relaxed">
        <p>
          <span className="font-medium text-[var(--espresso)]">Order by {fmt(CUTOFF_DATE)}</span> for Diwali delivery
          {daysLeft > 0 && <> — <span className="text-[var(--copper)]">{daysLeft} {daysLeft === 1 ? "day" : "days"} left</span></>}.
        </p>
        <p className="text-xs text-[var(--espresso)]/55 mt-1">Allow 8–12 business days total — 3–5 to craft, 5–7 to ship.</p>
      </div>
    </div>
  );
};

export default DiwaliBanner;
